class Polyline {
  constructor($element, index) {
    this.$element = $element;
    this.index = index;
    this.STROKE_DASHOFFSET = 240;
    this.MAX_DISTANCE = 300;
    this.updateCenter();
  }

  updateCenter() {
    const points = this.$element.getAttribute('points').split(' ');
    let xSum = 0;
    let ySum = 0;
    points.forEach((point, i) => {
      if (i % 2) {
        ySum += parseInt(point);
      } else {
        xSum += parseInt(point);
      }
    });
    this.centerX = xSum / (points.length / 2);
    this.centerY = ySum / (points.length / 2);
  }

  // calculate position relative to displayed size, screenX and screenY
  // @param {BoundingClientRect} svgRect - the rect of the parent <svg>
  updateScreenPosition(svgRect, viewBoxWidth, viewBoxHeight) {
    const scaleX = svgRect.width / viewBoxWidth;
    const scaleY = svgRect.height / viewBoxHeight;
    this.screenX = svgRect.x + window.scrollX + this.centerX * scaleX;
    this.screenY = svgRect.y + window.scrollY + this.centerY * scaleY;
  }

  getDistance(dx, dy) {
    return Math.sqrt(dx * dx + dy * dy);
  }

  renderHover(hoverX, hoverY) {
    const dx = this.screenX - hoverX;
    const dy = this.screenY - hoverY;
    const distance = this.getDistance(dx, dy);
    // if (this.index === 10 ) {
    //   console.log( `screen: ${~~this.screenX}, ${~~this.screenY}`, `hover: ${~~hoverX}, ${~~hoverY}`, ~~distance)
    // }
    // value from 0...1
    const alpha = Math.max(0, Math.min(1, distance / this.MAX_DISTANCE));
    const offset = alpha * this.STROKE_DASHOFFSET;
    this.$element.style.strokeDashoffset = `${offset}px`;
  }
}

class PatternReveal {
  constructor(el) {
    this.el = el;
    this.mount();
  }

  mount() {
    this.bindUI();
    this.bindEvents();
  }

  bindUI() {
    this.ui = {};
    this.ui.$svg = this.el.querySelector('svg');
    this.ui.$polylines = this.ui.$svg.querySelectorAll('polyline');
    this.svgRect = this.ui.$svg.getBoundingClientRect();
    this.viewBoxWidth = 600;
    this.viewBoxHeight = 440;

    this.ui.$polylines = [...this.ui.$polylines].map(($polyline, i) => {
      const polyline = new Polyline($polyline, i);
      polyline.updateScreenPosition(this.svgRect, this.viewBoxWidth, this.viewBoxHeight);
      return polyline;
    }).filter(Boolean);
  }

  bindEvents() {
    window.addEventListener('mousemove', this.onMouseover.bind(this));
  }

  onMouseover(event) {
    const hoverX = event.pageX;
    const hoverY = event.pageY;

    this.ui.$polylines.forEach((polyline) => {
      polyline.renderHover(hoverX, hoverY);
    });
  }
}

export default PatternReveal;
